import riskindicator from "./riskindicator.svg";
import riskIndicator2 from "./riskIndicator2.svg";
export default { riskindicator, riskIndicator2 };
